// extracted by mini-css-extract-plugin
export default {"subheading":"subheading__hCxIt","slider":"slider__mKw37"};